module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"msg1":"Symbol or Name"},"ar":{"msg1":"ابحث باسم / رمز الشركة"}}')
  delete Component.options._Ctor
}
